import type { SatDatepickerInputDirective } from '../directive/sat-datepicker-input.directive';

export interface SatDatepickerRangeValue<D> {
	begin: D | null;
	end: D | null;
}

export class SatDatepickerInputEvent<D> {
	value: SatDatepickerRangeValue<D> | D | null;

	constructor(
		public target: SatDatepickerInputDirective,
		public targetElement: HTMLElement
	) {
		this.value = target.value;
	}
}
